/*
 * Loading
 *
 * @props
*/
import React from 'react';
import {connect} from 'react-redux';

class Loading extends React.Component {
	constructor(props) {
		super(props);
	}

	render(){
		return (
			<div>
				<div className="loading-background" data-show-loading={this.props.loading.show ? 'in' : ''}>
					<div className="loading-container">
						<span className="icon-spinner"></span>
					</div>
				</div>
			</div>
		)
	}
}


const mapStateToProps = function (store) {
	return {
		loading: store.loadingState
	};
};

export default connect(mapStateToProps)(Loading);



// WEBPACK FOOTER //
// ./src/components/core/loading.component.jsx